import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InProgressIcon } from 'edenred-ui';

import { IExternalPayment } from '@epi-models/forms/PaymentMethod';

export const SingleCard = ({
  isLoading,
  method,
  isError
}: IExternalPayment) => {
  const { t } = useTranslation();

  return (
    <div className="ExternalPayment external-payment">
      {isLoading && !isError && <InProgressIcon />}{' '}
      {isLoading && !isError && t('application.loading')}
      {!isLoading && !isError && method && (
        <span key={method.code}>
          <Box id="create-external-payment-btn" className="external-payment">
            <img
              className="payment-type"
              alt={method.name}
              width="auto"
              height={40}
              src={method.image_url}
            />
          </Box>
        </span>
      )}
    </div>
  );
};
